import React from 'react';
import PropTypes from 'prop-types';

import withWindowResize from '../../../ui/components/window-resize';
import { withError } from '../../../shared/components/error-boundary';
import { Helpers } from '../../../core/src/helpers';
import Countdown from '../../../shared/components/countdown';

import './value-prop.less';

class ValueProp extends React.Component {

    static defaultProps = {
      background: "#ce0000",
      color: "#fff",
      exclude: [],
      patname: '',
      priority: 100,
    };

    static propTypes = {
      priority: PropTypes.number,
      title: PropTypes.string,
      body0: PropTypes.string,
      body1: PropTypes.string,
      mobile: PropTypes.string,
      cta: PropTypes.string,
      link: PropTypes.string,
      color: PropTypes.string,
      background: PropTypes.string,
      exclude: PropTypes.arrayOf(PropTypes.string),
    };

    isAbsolute = (url) => {
      return (/^(https?:)?\/\//i).test(url);
    }

  	goToLink = (e) => {
      const { valueProp={} } = this.props;
      const { link } = valueProp;
      /*check if target is <a> in mobile*/
      if (e && e.target && e.target.tagName === 'A') {
        return;
      } else {
        /* WE SHOULD BE ABLE TO USE THE HYPERLINK COMPONENT INSTEAD OF THIS CLICK HANDLER*/
        const [pathname, queryString] = link.split('?');
        if(this.isAbsolute(pathname)){
          // any idea why location.replace does not work properly here ?
          window.location.replace(link);
        }else{
          this.props.pushHistory(pathname, queryString);
        }
      }
    };

    render() {
      const { valueProp, pathname, width, isV2 } = this.props;
      if(!valueProp){
        return null;
      }
      let { background, color, exclude=[], endDate, link, disableCountdown } = valueProp;

      if (isV2) {
        background = '#AF1653';
      }

    	const vpStyle = {
	  		background,
	  		color,
	  	};
	  	const ctaStyle = {
        color: !isV2 ? background : 'white',
        background: !isV2 ? color : 'transparent',
        borderColor: color
      };
      //add current link to exlusion list by default
      exclude.push(link)
      let isExcluded = false;
      let linkPathname;

      for(let i = 0; i < exclude.length; i++) {
        const [url,] = exclude[i].split('?');
        if (this.isAbsolute(url)) {
          const newURL = new URL(url);
          linkPathname = newURL.pathname;
        } else {
          linkPathname = url;
        }
        
        if( ~pathname.indexOf( linkPathname ) ){      
          isExcluded = true;
          break;
        }
      }

      const isMobile = width <= 640;
      return !isExcluded && (
        <div 
          id={`vp-${valueProp.key}`} 
          className={`hp-value-prop${isMobile ? ' mobile' : ''}${isV2 ? ' v2' : ''}`} 
          style={vpStyle}
          onClick={ isMobile ? (e) => this.goToLink(e) : undefined }
        >
          <div tabIndex={0} className='vp-content'>
            <h3 className='vp-title'>{ valueProp.title }</h3>
            <p className='vp-body' dangerouslySetInnerHTML={Helpers.createMarkup(valueProp.body0)}></p>
            <p className='vp-text-mobile' dangerouslySetInnerHTML={Helpers.createMarkup(valueProp.mobile)}></p>
            { !isMobile && <button ref={vpCta => this.vpCta = vpCta} className="vp-cta" style={ctaStyle} onClick={this.goToLink}>{valueProp.cta}</button> }
            { !disableCountdown && !isMobile && endDate && 
              <div className="count-down-container">
                <Countdown 
                  endtime={endDate}
                  format={' h:m:s'}
                />
                <div className="time-name"><span>HRS </span><span>MINS </span><span>SECS </span></div>
              </div>
            }
          </div>
        </div>
      )
    }
}

export default withError(withWindowResize(ValueProp));